import TooltipIcon from "./TooltipIcon";

const Field = ({
  label,
  value,
  className,
  showLabel = true,
  icon,
  tooltip,
}) => {
  return (
    <div className={className || "mb-2"}>
      {showLabel && (
        <div className="field-label">
          {label}: {tooltip && <TooltipIcon text={tooltip} />}
        </div>
      )}
      {icon && <span className="field-icon">{icon}</span>}
      {value}
    </div>
  );
};

export default Field;
